import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
  open: false,
  loading: false,
  result: null,
  error: null,
  location: null,
  locationList: [],
};

const route = "modules/workOrders/views/locationTab/modals/deleteLocation/redux/slice";

export const workOrderDeleteLocation = createAsyncThunk("manage/deleteLocation/bulkDeleteCustomerLocation", async (payload, { rejectWithValue }) => {
  try {
    const response = await clientMutation(
      `mutation bulkDeleteCustomerLocation ($ids: [Int!]) {
        result: bulkDeleteCustomerLocation (ids: $ids)
      }`,
      payload,
      endpoints.GRAPHQL_GENERAL_V2
    );

    return { delete: response?.result }

  } catch (exc) {
    ExceptionManager(exc, route, "bulkDeleteCustomerLocation");
    return rejectWithValue(exc);
  }
}
);


const workOrdersDeleteLocationRedux = createSlice({
  name: "workOrders/deleteLocation",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload
        ? { ...state, ...action.payload }
        : { ...INIT_STATE };
    },
    openModalDeleteLocation(state, action) {
      state.open = true;
      state.location = action?.payload?.location;
      state.locationList = action?.payload?.locationList;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageDeleteManageWorkOrderType
    builder.addCase(workOrderDeleteLocation.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(workOrderDeleteLocation.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(workOrderDeleteLocation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersDeleteLocationRedux; 

// Extract and export each action creator by name
export const { reset, openModalDeleteLocation } = actions;

// Export the reducer, either as a default or named export
export default reducer;